import React, { FC, useState, useEffect } from 'react'
import { IonInput, IonModal, IonContent, useIonViewDidEnter, IonFooter } from '@ionic/react'
import { observer } from 'mobx-react'
import { memberMobx } from '@mobxStore'
import i18n from 'i18next'
import { toast } from '@utils'
import { UserNameInput } from '@cps'
import { CardShape, BackHeader, MktHeader } from 'pages/mkt/components'
import { format } from '@dt/fe-utils'
import './index.scss'

interface IProps {
  type: 'mobile' | 'email' | 'wechat';
  title?: string;
  sendInfo?: any;
  sendMessage?: string;
  reject?: () => void;
  resolve?: (value: any) => void;
}

const SendInfoModal: FC<IProps> = (props) => {
  const {
    type,
    title,
    sendInfo,
    sendMessage,
    reject,
    resolve
  } = props
  const [message, setMessage] = useState('')
  const [givePerson, setGivePerson] = useState(memberMobx.memberInfo.nickName || i18n.t('mkt.giftCard.tourist'))
  const [receivedPerson, setReceivedPerson] = useState('')
  const [userNameInfo, setUserNameInfo] = useState<any>({})
  const handleSave = () => {
    if (type === 'wechat') {
      resolve && resolve({ message: message || sendMessage || i18n.t('mkt.giftCard.sendMessage') })
      return
    }
    if (!userNameInfo.inputValue) {
      toast({ message: i18n.t(type === 'email' ? 'mkt.common.tipEmail' : 'mkt.common.tipMobile') })
      return
    } else if (!userNameInfo.valid) {
      toast({ message: i18n.t(type === 'email' ? 'mkt.common.tipEmailError' : 'mkt.common.tipMobileError') })
      return
    }
    if (!givePerson) {
      toast({ message: i18n.t('mkt.giftCard.tipGiver') })
      return
    }
    if (!receivedPerson) {
      toast({ message: i18n.t('mkt.giftCard.tipReceiver1') })
      return
    }
    resolve && resolve({ user: userNameInfo.inputValue, countryCode: userNameInfo.countryCode, message: message || sendMessage || i18n.t('mkt.giftCard.sendMessage'), givePerson, receivedPerson })
  }
  useIonViewDidEnter(() => {
    setUserNameInfo({})
    setMessage('')
    setGivePerson(memberMobx.memberInfo.nickName || i18n.t('mkt.giftCard.tourist'))
    setReceivedPerson('')
  })
  return (
    <IonModal
      isOpen
      data-cypid='mmgGiveInfoModal'
      cssClass='buy-giftcard-info-modify-modal'
    >
      {
        sendInfo?.shape
          ? <BackHeader onClick={() => reject()}></BackHeader>
          : <MktHeader title={title || i18n.t('mkt.giftCard.transferInfo')} onBack={reject}></MktHeader>
      }
      <IonContent className={`${sendInfo ? 'ion-content' : ''}`}>
        <div className={`modal-content${sendInfo ? ' send-info-style' : ''}`}>
          {
            sendInfo?.shape
              ? (
                <>
                  <div className='send-info-title'><span>{title}</span>{sendInfo?.price && <span className='send-info-price'>{format.toPrice(sendInfo.price)}</span>}</div>
                  <div className='send-info-shape' style={{ height: sendInfo?.shape === 'rectangle' ? 'calc((100vw - 76px) * 0.67)' : 'calc(100vw - 76px)' }}><CardShape cardFace={sendInfo.img} border='border' shape={sendInfo.shape} isScale={false}></CardShape></div>
                </>
              ) : (
                <div className='send-info-area'>
                  {sendInfo?.cnt > 1 && <div className='send-info-cnt'></div>}
                  {sendInfo?.img && <div className='send-info-img' style={{ backgroundImage: `url(${sendInfo?.img})` }}></div>}
                  {sendInfo?.img && <div className='send-info-line'></div>}
                  <div className={`send-info-text${sendInfo?.img ? '' : ' send-info-clc'}`}>
                    <div className='send-info-text-top'>{sendInfo?.title}</div>
                    <div>{sendInfo?.desc}</div>
                  </div>
                </div>
              )
          }
          <div className='input-area'>
            <div className='input-item'>
              <div className='title'>
                <span>{i18n.t('mkt.giftCard.message')}</span>
                <span className='extra'>{message.length}/{type === 'mobile' ? 100 : 280}</span>
              </div>
              <textarea
                data-cypid='mmgGiveMessage'
                className='mkt-text-area' maxLength={type === 'mobile' ? 100 : 280} value={message} placeholder={sendMessage ? `「${sendMessage}」` : i18n.t('mkt.giftCard.tipBuyRemark')}
                onChange={(e: any) => {
                  setMessage(e.target.value)
                }}
              />
            </div>
            {
              type !== 'wechat' &&
                <>
                  <div className='input-item'>
                    <div className='title'>{i18n.t('mkt.giftCard.receiver')}</div>
                    <div className='mkt-input'>
                      <IonInput data-cypid='mmgReceivePerson' maxlength={30} value={receivedPerson} placeholder={i18n.t('mkt.giftCard.receivePlace')} onIonChange={(e: any) => setReceivedPerson(e.detail.value)} />
                    </div>
                  </div>
                  <div className='input-item'>
                    <div className='title'>{type === 'email' ? i18n.t('mkt.giftCard.signEmail') : i18n.t('mkt.giftCard.signMobile')}</div>
                    <UserNameInput data-cypid='mmgReceiveEmail' type={type} onChange={(val: any) => setUserNameInfo(val)}></UserNameInput>
                  </div>
                  <div className='input-item'>
                    <div className='title'>{i18n.t('mkt.giftCard.giver')}</div>
                    <div className='mkt-input'>
                      <IonInput data-cypid='mmgGivePerson' maxlength={30} value={givePerson} placeholder={i18n.t('mkt.giftCard.givePlace')} onIonChange={(e: any) => setGivePerson(e.detail.value)} />
                    </div>
                  </div>
                </>
            }
          </div>
        </div>
      </IonContent>
      <IonFooter className='send-info-footer'>
        <div data-cypid='mmgSentGCard' onClick={handleSave} className={`send-info-btn${sendInfo ? ' send-info-btn2' : ''}`}>{i18n.t('mkt.common.confirm')}</div>
      </IonFooter>
    </IonModal>
  )
}

export default observer(SendInfoModal)
